import PropTypes from 'prop-types';
import { memo } from 'react';
// @mui
import { Stack } from '@mui/material';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array,
  user: PropTypes.object
};

function NavSectionHorizontal({ user, navConfig }) {
  return (
    <Stack direction="row" justifyContent="center" sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 0.5 }}>
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {navConfig.map((group) => (
          <Stack key={group.subheader} direction="row" flexShrink={0}>
            {group.items.map((list) => {              
              console.log("listap23", list)
              return user.roles.some(e => e.name === list.role) &&<NavListRoot key={list.title} list={list} />
            }              
            )}
          </Stack>
        ))}
      </Stack>
    </Stack>
          //  return user.roles.some(e => e.name === list.role) && <NavListRoot key={list.title} list={list} isCollapse={isCollapse} notifications={notifications}/>

  );
}

export default memo(NavSectionHorizontal);
